import React, { Component } from 'react'
import { Button, Row, Table, Popconfirm, Tooltip, Form, Col, Pagination, Checkbox, Modal, Select } from 'antd'
import _ from 'underscore'
import PropTypes from 'prop-types'
import underscore from "underscore"
import { api, app } from "../../app"
import utils from "../../utils"
import ReviewSearch from "../../components/ReviewSearch"
import common from "./common"

const Option = Select.Option

class ReTransferTeam extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data_loading: true,
            auditList: [],
            posttionList: [],
            reviewInfo: {},
            selectedRowKeys: [],
            total: 0,
            page: 1,
            dataType: '1',
            search_type: 'searchform_name',
            search_val: '',
        }
    }

    /**
     * 设置值
     * @param data
     * @param cb
     */
    setData = async (data) => app.setStateSync(this, data)

    async componentDidMount() {
        this._isMounted = true
        this.dataSource()
        await this.PosttionData()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 数据源
     * @param page
     */
    dataSource = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let { dataType, search_type, search_val } = this.state, params = {
            page,
            search_val,
            search_type,
            type: dataType,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, total } = await app.post(api.JoinTeamList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            await this.setData({
                selectedRowKeys: [],
                data_loading: false,
                auditList: utils.addArrayKey(data),
                total: parseInt(total || 0),
            })
        }
    }

    /**
     * 职务列表
     **/
    PosttionData = async () => {
        let { flag, data, msg } = await app.post(api.PosttionList)
        if (flag === 1) {
            const rights = app.getData('rights')
            let posttionList = data
            if (rights === 1) {
                posttionList = underscore.map(data, (posttion) => {
                    posttion.permiss = ''
                    return posttion
                })
            }
            await this.setData({ posttionList })
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 页码修改
     * @param page
     */
    handlePageChange = async (page) => {
        await this.dataSource(page)
    }

    /**
     * 全选
     * @param e
     * @returns {Promise<void>}
     */
    handleAllSel = async (e) => {
        let checked = e.target.checked
        let selectedRowKeys = []
        if (checked) {
            selectedRowKeys = _.range(1, this.state.auditList.length + 1)
        }
        await this.setData({ selectedRowKeys })
    }

    /**
     * 批量审核
     * @param type
     */
    handlePLReview = async (type) => {
        let { selectedRowKeys, auditList, page, total } = this.state, len = selectedRowKeys.length
        if (len === 0) {
            app.alert('请选择审核内容', 'warn')
            return
        }
        let tp = parseInt((total - len) / 20)
        tp = (total - len) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }
        let id = [], audit_type = '', original_status = '',apply_type='';
        for (let i = 0; i < selectedRowKeys.length; i++) {
            let audit = auditList[selectedRowKeys[i] - 1]
            if (audit_type && audit.type !== audit_type) {
                app.alert('转队与加入不能一起审核');
                return;
            }
            if (original_status && audit.original_status !== original_status) {
                app.alert('审核状态不一致');
                return;
            }
            if (apply_type && audit.apply_type !== apply_type) {
                app.alert('申请类型不一致');
                return;
            }
            audit_type = audit.type;
            original_status = audit.original_status;
            apply_type = audit.apply_type;
            id.push(audit.id);
        }
        let reviewInfo = {
            id: id.join(','),
            uri: api.JoinTeamAudit,
            id_key: "id",
            source: () => this.dataSource(tp),
        }
        if (type === 1) {
            if (audit_type === '1' && original_status === '1'&&apply_type === '0' ) {
                this.OpenZhuanDuiModal(reviewInfo)
            }else {
                this.props.successReview(1, "", reviewInfo)
            }
        } else if (type === 2) {
            this.props.failReview(reviewInfo)
        } 
    }

    /**
     * 打开通过审核对话框
     **/
    OpenZhuanDuiModal = (reviewInfo) => {
        this.setState({ zhuandui_visible: true, reviewInfo })
    }

    /**
     * 搜索
     * @param search_type
     * @param search_val
     */
    handleSearch = async (search_type, search_val) => {
        await this.setData({ search_type, search_val })
        await this.dataSource()
    }

    /**
     * 关闭通过审核对话框
     * @constructor
     */
    CloseZhuanDuiModal = () => {
        this.setState({ zhuandui_visible: false, reviewInfo: {} }, () => {
            this.props.form.resetFields()
        })
    }

    /**
     * 提交通过
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                const { reviewInfo } = this.state
                const { team_position_id } = values
                values.team_position_id = team_position_id.join(',')
                const res = await this.props.successReview(1, "", reviewInfo, values)
                if (res) {
                    this.CloseZhuanDuiModal()
                }
            }
        })
    }

    render() {
        let { data_loading, auditList, total, page, selectedRowKeys, dataType, zhuandui_visible, posttionList } = this.state,
            tp = parseInt((total - 1) / 20),
            { getFieldDecorator } = this.props.form,
            formItemLayout = {
                labelCol: { span: 8 },
                wrapperCol: { span: 15, offset: 1 },
            }
        tp = (total - 1) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }

        let columns = [
            {
                title: '姓名',
                dataIndex: 'vname',
                key: 'vname',
                width: '7%'
            },
            {
                title: '队员编号',
                dataIndex: 'original_bsrno',
                key: 'original_bsrno',
                width: '7%'
            },
            {
                title: '目前所属队伍',
                dataIndex: 'original_teamname',
                key: 'original_teamname',
                width: '7%'
            },
            {
                title: '申请队伍',
                dataIndex: 'current_teamname',
                key: 'current_teamname',
                width: '7%'
            },
            {
                title: '状态',
                dataIndex: 'type',
                key: 'type',
                width: '7%',
                render(text) {
                    switch (text) {
                        case "1":
                            return (<span>转队</span>)
                        case "2":
                            return (<span>加入</span>)
                    }
                    return (<span>无</span>)
                }
            },
            {
                title: '申请队伍职务',
                key: 'teampositionname',
                width: '5%',
                render(data) {
                    if (data.teampositionname) {
                        return (<span>{data.teampositionname}</span>)
                    }
                    return (<span>无</span>)
                }
            },
            {
                title: '申请类型',
                dataIndex: 'apply_type',
                key: 'apply_type',
                width: '10%',
                render(apply_type) {
                    switch (apply_type) {
                        case "0":
                            return (<span>系统操作</span>)
                        case "1":
                            return (<span>筹备组申请</span>)
                        case "2":
                            return (<span>筹备组转筹备队</span>)
                        case "3":
                            return (<span>筹备队转正式队</span>)
                    }
                    return (<span>无</span>)
                }
            },
            {
                title: '申请时间',
                dataIndex: 'cteate_time',
                key: 'cteate_time',
                width: '13%',
                render(text) {
                    return (<span>{text || '-'}</span>)
                }
            },
            {
                title: '原队伍审核',
                dataIndex: 'original_status',
                key: 'original_status',
                width: '13%',
                render: (audit, { original_team_indexno, original_time, detail }) => common.tableStatus(audit, original_team_indexno, original_time, detail)
            },
        ], rowSelection = null
        if (dataType === '1') {
            rowSelection = {
                selectedRowKeys,
                onChange: async (selectedRowKeys) => {
                    await this.setData({ selectedRowKeys })
                }
            }
            columns.push({
                title: '操作',
                dataIndex: 'id',
                key: 'sjglycz',
                width: '24%',
                render: (text, record) => {
                    let reviewInfo = {
                        id: text,
                        uri: api.JoinTeamAudit,
                        id_key: "id",
                        source: () => this.dataSource(tp),
                    }, disabled = selectedRowKeys.length > 1
                    return (
                        <div>
                            {/* {console.log(record)} */}
                            <Tooltip title={record.reason} placement="left">
                                <span className="link">申请原因</span>
                            </Tooltip>
                            {
                                record.original_status === "1" && record.type === "1" && record.apply_type === "0"  ?
                                    (
                                        <Button size="small" type="primary" style={{ margin: "0 20px" }} disabled={disabled}
                                            onClick={() => {
                                                this.OpenZhuanDuiModal(reviewInfo)
                                            }}>通过</Button>
                                    ) :
                                    (
                                        <Popconfirm placement="bottom"
                                            title="确定审核通过吗？"
                                            cancelText="取消"
                                            okText="确定"
                                            onConfirm={() => this.props.successReview(1, "", reviewInfo)}
                                        >
                                            <Button disabled={disabled} size="small" type="primary" style={{ margin: "0 20px" }}>通过</Button>
                                        </Popconfirm>
                                    )
                            }
                            <Button disabled={disabled} size="small" type="danger" onClick={() => {
                                this.props.failReview(reviewInfo)
                            }} ghost>不通过</Button>
                        </div>
                    )
                }
            })
        } else {
            columns.push(
                {
                    title: '现队伍审核',
                    dataIndex: 'current_status',
                    key: 'current_status',
                    width: '14%',
                    render: (audit, { current_team_indexno, current_time, detail }) => common.tableStatus(audit, current_team_indexno, current_time, detail)
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    key: 'sjglycz',
                    width: '10%',
                    render: (text, record) => {
                        return (
                            <div>
                                <Tooltip title={record.reason} placement="left">
                                    <span className="link">申请原因</span>
                                </Tooltip>
                            </div>
                        )
                    }
                })
        }

        return (
            <div style={{ height: '100%' }}>
                <div>
                    <span>审核状态： </span>
                    <Select defaultValue="1" style={{ width: 120, marginBottom: 20 }} onChange={async (value) => {
                        await this.setData({ dataType: value })
                        await this.dataSource()
                    }}>
                        <Option value="1">未审核</Option>
                        <Option value="2">已审核</Option>
                    </Select>
                    <ReviewSearch onSearch={this.handleSearch} />
                </div>
                <Table columns={columns}
                    locale={app.tbLocale(data_loading)}
                    dataSource={auditList}
                    loading={data_loading}
                    scroll={{ y: 'calc(100% - 103px)' }}
                    style={{ height: 'calc(100% - 52px)' }}
                    rowSelection={rowSelection}
                    pagination={false}
                    footer={() => {
                        return (
                            <Row hidden={auditList.length === 0}>
                                <Col span={10}>
                                    <div hidden={dataType === '2'}>
                                        <Checkbox
                                            checked={auditList.length !== 0 && auditList.length === selectedRowKeys.length}
                                            onChange={this.handleAllSel}>全选</Checkbox>
                                        <Button style={{ margin: '0 20px' }} type="primary"
                                            onClick={() => this.handlePLReview(1)}>通过</Button>
                                        <Button type="danger" onClick={() => this.handlePLReview(2)}>不通过</Button>
                                    </div>
                                </Col>
                                <Col span={14} style={{ textAlign: 'right' }}>
                                    <Pagination total={total} size="small" pageSize={20} current={page}
                                        showTotal={(total) => `总数量：${total}`}
                                        onChange={this.handlePageChange} />
                                </Col>
                            </Row>
                        )
                    }}
                    size="small"
                />
                <Modal
                    visible={zhuandui_visible}
                    onOk={this.handleSubmit}
                    onCancel={this.CloseZhuanDuiModal}
                    okText="确定"
                    cancelText="取消"
                    title="转队信息编辑"
                    maskClosable={false}
                    keyboard={false}
                    style={{ top: '30%' }}
                >
                    <Form>
                        <Form.Item
                            label="身份"
                            {...formItemLayout}
                        >
                            {getFieldDecorator('identity', {
                                rules: [
                                    { required: true, message: '请选择身份!' },
                                ],
                            })(
                                <Select placeholder="请选择身份">
                                    <Option value="1">队员</Option>
                                    {/*<Option value="2">预备队员</Option>*/}
                                    {/*<Option value="3">认证志愿者</Option>*/}
                                    {/*<Option value="6">志愿者</Option>*/}
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item
                            label="队内职位"
                            {...formItemLayout}
                        >
                            {getFieldDecorator('team_position_id', {
                                rules: [
                                    { required: true, message: '请选择队内职位!' },
                                ],
                            })(
                                <Select mode="multiple" placeholder="请选择队员队内职务" notFoundContent="无"
                                    optionFilterProp="children">
                                    {
                                        posttionList.map((posttion, index) => {
                                            return (
                                                <Option key={index + 1} value={posttion.position_id}
                                                    disabled={posttion.permiss === 'all'}>{posttion.position_name}</Option>
                                            )
                                        })
                                    }
                                </Select>
                            )}
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        )
    }
}

ReTransferTeam.propTypes = {
    successReview: PropTypes.func.isRequired,   //审核通过处理
    failReview: PropTypes.func.isRequired,  //审核失败处理
}

export default Form.create()(ReTransferTeam)



// WEBPACK FOOTER //
// ./src/routes/review/ReTransferTeam.jsx